import { FC } from 'react';

export const Animation: FC<{ onComplete: () => void }> = () => null;
